import { z } from 'zod';

import { pathOrUrl } from '../../utils';
import { PackSchema } from './Pack';

export const BoxSchema = z.object({
    color: z.string(),
    image: pathOrUrl,
    pack: PackSchema,
});

export type Box = z.infer<typeof BoxSchema>;
